import { Outlet, Navigate } from 'react-router-dom';
import Navbar from '../home/Navbar';
import Footer from '../home/Footer';
import { useAuth } from '../../context/AuthContext';

export default function PublicLayout() {
    const { isAuthenticated } = useAuth();

    // OPTIONAL: If we want to force redirected logged-in users away from public pages:
    // if (isAuthenticated) {
    //   return <Navigate to="/dashboard" replace />;
    // }
    // However, usually users can still view the homepage. 
    // BUT the prompt says: "Before login... After login... HIDE all public tabs... SHOW dashboard tabs".
    // This implies if I am logged in, I effectively get the Dashboard Layout if I am "in the app".
    // Typically, marketing pages remain accessible. But to STRICTLY follow "Navigation MUST be auth-aware",
    // if I am logged in, I usually shouldn't see the "Get Started" buttons in the same way.
    // The Prompt says: "This is a hard replacement... navigation changes based on authentication state".
    // I will assume PublicLayout is mostly for unauthenticated users. If an authenticated user lands here,
    // they see the public content with the Public Navbar.
    // However, the User Objective says "App Shell Structure... If authenticated -> render DashboardLayout".
    // This implies we might want to redirect authenticated users to Dashboard OR show Dashboard Navbar even on Home?
    // "If unauthenticated -> render PublicLayout... If authenticated -> render DashboardLayout".
    // This suggests a TOP LEVEL switch. 
    // If I strictly follow "If authenticated -> render DashboardLayout", then the user CANNOT see the Landing Page when logged in.
    // This is common in some apps (e.g. Linear, Facebook).
    // I will implement this redirects logic in the Route definition or AppShell, not strictly here, 
    // but let's keep this component simple: Navbar + Outlet + Footer.

    return (
        <div className="bg-black min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
